import React, { Component } from 'react';
import Icon, { Explosion } from 'components/icons';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    
    if (hasError) {
      return (
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className="text-center">
            <Icon icon={Explosion} size={128} />
            <h5 className="serif mt-4">Oh no, something went wrong!</h5>
            <p>Our team has been notified, but click here to fill out a report. It'll help us make sure it doesn't happen again!</p>
          </div>
        </div>
      );
    }

    return children;
  }
}
